import React from 'react';
import styles from '../../Forms.module.css';
import { IconButton } from '@material-ui/core';

const TextInput = (props) => {
  const {
    input,
    meta: { error },
    label,
    getLabel,
    required,
    autoFocus,
    placeholder,
    disabled,
    inline,
    type = 'text',
    rightIcon: RightIcon,
    onRightIconClick,
  } = props;

  const inputComponent =
    typeof getLabel === 'function' ? (
      getLabel()
    ) : (
      <span className={styles.label} style={required ? {} : { paddingLeft: 0 }}>
        {label}
      </span>
    );

  const cn = inline ? styles.inputRowGroup : styles.inputGroup;
  const handleKeyDown = (e) => {
    if (e.key === ' ' && e.target.value.length === 0) {
      e.preventDefault();
    }
  };
  return (
    <label className={cn} htmlFor={input.name}>
      {required && <span className={styles.required}>*</span>}
      {inputComponent}
      <div style={{ position: 'relative' }}>
        <input
          {...input}
          autoComplete="off"
          className={styles.input}
          type={type}
          disabled={disabled}
          required={required}
          id={input.name}
          autoFocus={autoFocus}
          placeholder={placeholder}
          onKeyDown={handleKeyDown}
          style={{ width: '100%', ...(!!RightIcon ? { paddingRight: 30 } : {}) }}
        />
        {!!RightIcon && (
          <IconButton
            onClick={() => {
              onRightIconClick && onRightIconClick();
            }}
            className={styles.rightIconBtn}
          >
            <RightIcon />
          </IconButton>
        )}
      </div>
      {error && <span className={styles.error}>{error}</span>}
    </label>
  );
};

export default TextInput;
